import CurrencyInput from 'components/ReusableComponents/CurrencyInput'
import MultiSelectDropdown from 'components/ReusableComponents/MultiSelectDropdown'
import { invoiceStatusesAcceptableForTotalDueCalculation } from 'features/Billing/statusNames'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import paymentApi from 'services/api/payment'

import styles from './IncomingACHCredit.module.scss'

const IncomingACHCredit = () => {
  const { addToast } = useToasts()

  const invoices = useSelector(s => s.billing.invoices)
  const activeInvoices =
    invoices?.filter(invoice =>
      invoiceStatusesAcceptableForTotalDueCalculation.includes(invoice.status)
    ) ?? []

  const [isLoading, setIsLoading] = React.useState(false)
  const [isSuccess, setIsSuccess] = React.useState(false)

  const {
    control,
    register,
    handleSubmit,
    formState: { isValid }
  } = useForm({
    defaultValues: {
      creditAmount: '$0.00',
      note: '',
      adviceNumber: '',
      invoiceIds: []
    }
  })

  const onSubmit = handleSubmit(data => {
    setIsLoading(true)

    paymentApi
      .addACHCredit({
        creditAmount: data.creditAmount.replace(/[$,]/gi, ''),
        note: data.note,
        adviceNumber: data.adviceNumber,
        invoiceIds: data.invoiceIds
      })
      .then(() => {
        addToast('ACH credit added successfully', {
          appearance: 'success'
        })
        setIsSuccess(true)
      })
      .catch(err => {
        addToast(err.message, {
          appearance: 'error'
        })
        setIsSuccess(false)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, console.error)

  if (isSuccess) {
    return <Redirect to="/billing" />
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Credit amount</span>
            <Controller
              control={control}
              name="creditAmount"
              render={({ field: { onChange, value } }) => (
                <CurrencyInput
                  className={styles.currencyInput}
                  value={value}
                  onChange={onChange}
                />
              )}
              rules={{
                required: true
              }}
            />
          </label>
        </div>
        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Reason for adding credit</span>
            <input
              className={styles.textInput}
              placeholder="Why are you adding credit?"
              {...register('note', {
                required: true
              })}
            />
          </label>
        </div>
      </div>

      <div className={styles.content}>
        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Advice Number</span>
            <input
              className={styles.currencyInput}
              placeholder="Advice Number"
              {...register('adviceNumber', {
                required: true
              })}
            />
          </label>
        </div>

        <div className={styles.inputHolder}>
          <label className={styles.currencyLabel}>
            <span className={styles.currencyLabelText}>Invoice Id</span>
            <Controller
              control={control}
              name="invoiceIds"
              render={({ field: { onChange, value } }) => (
                <MultiSelectDropdown
                  className={styles.textInput}
                  itemName="Invoice"
                  itemNamePlural="Invoices"
                  value={value}
                  onChangeValue={onChange}
                  options={activeInvoices.reduce((acc, invoice) => {
                    acc[invoice.subsidiaryInvoiceId] = `#${invoice.subsidiaryInvoiceId}`
                    return acc
                  }, {})}
                />
              )}
              rules={{
                required: true
              }}
            />
          </label>
        </div>
      </div>
      <div className={styles.controls}>
        <Link to="/billing">
          <button className={styles.secondaryButton}>Cancel</button>
        </Link>
        <button
          disabled={!isValid || isLoading}
          onClick={onSubmit}
          className={styles.primaryButton}
        >
          Save &amp; confirm payment
        </button>
      </div>
    </div>
  )
}

export default IncomingACHCredit
